import { Datagrid, DateField, EditButton, List, NumberField, ReferenceField, ReferenceInput, TextField, useRecordContext } from 'react-admin';
import { url_image } from '../constant/constant';
import { DateInput, getStringFromDate, MaterialUIPickers } from '../constant/DateInput';
import { Edit, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { FunctionField } from 'react-admin';


const CustomImageField = ({ source, width, marginTop }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    return (<img src={url_image + record[source]} width={width} style={{ marginTop: marginTop }} />);
};

const CustomNumberField = ({ source }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    return (<span style={{ color: record[source] <= 3 ? "red" : "black" }}>{record[source]}</span>);
};

const reportFilters = [
    <DateInput source="created_at"
        // views={["year", "month"]} 
        parse={val => getStringFromDate(val).substring(0, 10)}
        inputFormat="dd MMMM yyyy"
        // alwaysOn 
        label="Tanggal Layanan"
    />,
];

const ConditionalEditButton = () => {
  const record = useRecordContext();
  if (!record) return null;

  const values = [record.p1, record.p2, record.p3, record.p4, record.p5, record.p6, record.p7];
  const shouldShow = values.some(val => val < 4);

  return shouldShow ? <EditButton label="Input Masukan Pengunjung" sx={{ textTransform: 'none' }} /> : null;
};





export const SurveyList = () => (
    <List filters={reportFilters} sort={{ field: 'created_at', order: 'DESC' }} >
        <Datagrid isRowSelectable={false} bulkActionButtons={false}>
            {/* <TextField source="id" /> */}
            {/* <NumberField source="id_pengunjung" /> */}
            <ReferenceField label="Foto Pengunjung" source="id_pengunjung" reference="queue" link={false} >
                {/* <TextField source="nama_kab" /> */}
                <CustomImageField source="foto_pengunjung_path" label="Foto Pengunjung" width={120} marginTop={0} />
            </ReferenceField>
            {/* <TextField source="niplama_petugas" /> */}
            <ReferenceField label="Nama Petugas PST" source="niplama_petugas" reference="petugas_pst" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            <FunctionField
            label="Petugas pelayanan merespon dengan baik"
            source="p1"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p1 <= 3 ? 'red' : 'black' }}>{record.p1}</span>
                {record.konsultasi_tidak_puas && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas}
                    </span>
                )}
                </div>
            )}
            />

            <FunctionField
            label="Kerapihan Petugas Pelayanan"
            source="p2"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p2 <= 3 ? 'red' : 'black' }}>{record.p2}</span>
                {record.konsultasi_tidak_puas_p2 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p2}
                    </span>
                )}
                </div>
            )}
            />
            <FunctionField
            label="Petugas Pelayanan Menerapkan Budaya Senyum"
            source="p3"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p3 <= 3 ? 'red' : 'black' }}>{record.p3}</span>
                {record.konsultasi_tidak_puas_p3 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p3}
                    </span>
                )}
                </div>
            )}
            />
            <FunctionField
            label="Petugas Pelayanan Menerapkan Budaya Sapa"
            source="p4"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p4 <= 3 ? 'red' : 'black' }}>{record.p4}</span>
                {record.konsultasi_tidak_puas_p4 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p4}
                    </span>
                )}
                </div>
            )}
            />
            <FunctionField
            label="Petugas Pelayanan Menerapkan Budaya Salam"
            source="p5"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p5 <= 3 ? 'red' : 'black' }}>{record.p5}</span>
                {record.konsultasi_tidak_puas_p5 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p5}
                    </span>
                )}
                </div>
            )}
            />  
            <FunctionField
            label="Petugas Pelayanan Menerapkan Budaya Sopan"
            source="p6"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p6 <= 3 ? 'red' : 'black' }}>{record.p6}</span>
                {record.konsultasi_tidak_puas_p6 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p6}
                    </span>
                )}
                </div>
            )}
            />
            <FunctionField
            label="Petugas Pelayanan Menerapkan Budaya Santun"
            source="p7"
            sortable
            render={record => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: record.p7 <= 3 ? 'red' : 'black' }}>{record.p7}</span>
                {record.konsultasi_tidak_puas_p7 && (
                    <span style={{ fontSize: '0.85em', color: '#555', marginTop: 4 }}>
                    {record.konsultasi_tidak_puas_p7}
                    </span>
                )}
                </div>
            )}
            />
         
            <TextField source="saran" />
            <DateField source="created_at" label="Tanggal Layanan" locales="id-ID" />
            <ConditionalEditButton  />
        </Datagrid>

    </List>
);



// export const SurveyEdit = () => (
//     <Edit>
//         <SimpleForm>
//             <TextInput source="id" />
//             <NumberInput source="id_pengunjung" />
//             <NumberInput source="niplama_petugas" />
//             <NumberInput source="p1" />
//             <NumberInput source="p2" />
//             <NumberInput source="p3" />
//             <NumberInput source="p4" />
//             <NumberInput source="p5" />
//             <NumberInput source="p6" />
//             <NumberInput source="p7" />
//             <NumberInput source="p8" />
//             <NumberInput source="p9" />
//             <NumberInput source="p10" />
//             <TextInput source="saran" />
//             <TextInput source="konsultasi_tidak_puas" />
//             <DateInput source="created_at" />
//         </SimpleForm>
//     </Edit>
// );

const P1FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p1 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p1"
          label="Petugas pelayanan merespon dengan baik"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};



const P2FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p2 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p2"
          label="Kesiapan Petugas Pelayanan"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p2"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

const P3FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p3 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p3"
          label="Petugas Pelayanan Menerapkan Budaya Senyum"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p3"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

const P4FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p4 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p4"
          label="Petugas Pelayanan Menerapkan Budaya Sapa"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p4"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

const P5FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p5 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p5"
          label="Petugas Pelayanan Menerapkan Budaya Salam"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p5"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

const P6FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p6 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p6"
          label="Petugas Pelayanan Menerapkan Budaya Sopan"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p6"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

const P7FeedbackFields = () => {
  const record = useRecordContext();
  if (!record || record.p7 >= 4) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
      <div style={{ flex: 1 }}>
        <NumberInput
          source="p7"
          label="Petugas Pelayanan Menerapkan Budaya Santun"
          disabled
          fullWidth
        />
      </div>
      <div style={{ flex: 2 }}>
        <TextInput
          source="konsultasi_tidak_puas_p7"
          label="Alasan Konsultasi tidak puas"
          multiline
          fullWidth
        />
      </div>
    </div>
  );
};

export const SurveyEdit = () => (
    <Edit>
  <SimpleForm style={{ display: "flex", flexDirection: "column", gap: 24 }}>

    {/* Top Section: ID + Petugas + Photo */}
    <div style={{ display: "flex", flexDirection: "row", gap: 24, alignItems: "flex-start", width: "100%" }}>
      <div style={{ flex: 1 }}>
        <NumberInput source="id_pengunjung" disabled fullWidth />
        <NumberInput source="niplama_petugas" disabled fullWidth />
      </div>

      <div style={{ flexShrink: 0 }}>
        <ReferenceField
          label="Foto Pengunjung"
          source="id_pengunjung"
          reference="queue"
          link={false}
        >
          <CustomImageField
            source="foto_pengunjung_path"
            label="Foto Pengunjung"
            width={300}
            marginTop={10}
          />
        </ReferenceField>
      </div>
    </div>


      <P1FeedbackFields />
      <P2FeedbackFields />
      <P3FeedbackFields />
      <P4FeedbackFields />
      <P5FeedbackFields />
      <P6FeedbackFields />
      <P7FeedbackFields />
    

  </SimpleForm>
</Edit>
);